import { Link } from 'react-router-dom';
import { Container, Title, Text, Stack, Group, Badge, Card, Skeleton, SimpleGrid } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { hashtagsService } from '../../services/hashtags';

export default function TagsBrowse() {
  const { data: trending, isLoading: loadingTrending } = useQuery({
    queryKey: ['hashtags-trending-7d'],
    queryFn: () => hashtagsService.getTrending(168, 20),
    staleTime: 15 * 60 * 1000,
  });

  const { data: recent, isLoading: loadingRecent } = useQuery({
    queryKey: ['hashtags-trending-24h'],
    queryFn: () => hashtagsService.getTrending(24, 20),
    staleTime: 5 * 60 * 1000,
  });

  return (
    <Container size="md" py="xl">
      <Stack gap="xl">
        <Title order={2}>Browse Hashtags</Title>

        {/* 7-day trending */}
        <Stack gap="sm">
          <Text fw={700} size="sm" tt="uppercase" c="dimmed">Trending this week</Text>
          {loadingTrending ? (
            <SimpleGrid cols={2} spacing="sm">
              {Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} h={80} radius="md" />)}
            </SimpleGrid>
          ) : (
            <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="sm">
              {(trending ?? []).map(tag => (
                <Card
                  key={tag.id}
                  component={Link}
                  to={`/tags/${tag.slug}`}
                  radius="md"
                  withBorder
                  p="md"
                  style={{ textDecoration: 'none' }}
                >
                  <Group justify="space-between" align="flex-start" wrap="nowrap">
                    <Text fw={700} size="sm">#{tag.name}</Text>
                    <Badge size="xs" variant="light" radius="xl">
                      {tag.recentCount ?? tag.reviewCount} this week
                    </Badge>
                  </Group>
                  <Text size="xs" c="dimmed" mt={4}>{tag.reviewCount} reviews total</Text>
                </Card>
              ))}
            </SimpleGrid>
          )}
        </Stack>

        {/* Recently active (24h) */}
        <Stack gap="sm">
          <Text fw={700} size="sm" tt="uppercase" c="dimmed">Active today</Text>
          {loadingRecent ? (
            <Group gap={8} wrap="wrap">
              {Array.from({ length: 10 }).map((_, i) => <Skeleton key={i} h={28} w={90} radius="xl" />)}
            </Group>
          ) : (
            <Group gap={8} wrap="wrap">
              {(recent ?? []).map(tag => (
                <Badge
                  key={tag.id}
                  component={Link}
                  to={`/tags/${tag.slug}`}
                  variant="outline"
                  radius="xl"
                  size="md"
                  style={{ cursor: 'pointer', textDecoration: 'none' }}
                >
                  #{tag.name}
                  <Text span c="dimmed" size="xs" ml={4}>({tag.recentCount})</Text>
                </Badge>
              ))}
            </Group>
          )}
        </Stack>
      </Stack>
    </Container>
  );
}
